var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":_vm.height,"width":_vm.width}},[_c('path',{attrs:{"d":"M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z","fill":_vm.color}})])
}
var staticRenderFns = []

export { render, staticRenderFns }